import { ActionTypes } from 'src/store/actions/offlineLockCardsActions';
export const initialState = {
    list: [],
    types: []
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.LOAD_CARDS: {
            return { ...state, list: payload };
        }
        case ActionTypes.LOAD_CARD_TYPES: {
            return { ...state, types: payload };
        }
        case ActionTypes.POST_CARD: {
            const list = state.list;
            const newCard = payload;
            return { ...state, list: [newCard].concat(list) };
        }
        case ActionTypes.PUT_CARD: {
            return {
                ...state,
                list: state.list
                    ? state.list.map((entry) => (entry.Id === payload.Id ? payload : entry))
                    : [payload]
            };
        }
        case ActionTypes.DELETE_CARD: {
            return {
                ...state,
                list: state.list
                    ? state.list.filter((entry) => entry.Id !== payload)
                    : []
            };
        }
        default: {
            return state;
        }
    }
};
